import React from 'react'
import { Navigate } from 'react-router-dom'

const Callback = () => {
	return <Navigate to={'/xero/connections'} />
}

export default Callback
